import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import type { FC } from 'react';
import Slider from 'react-slick';

import { SLIDER_SETTINGS, SliderBox } from 'components/SliderWrapper';

import NfcStepContent from './NfcStepContent';

export interface NfcStep {
  image: string;
  alt: string;
  step: number;
  text: string;
}

const NFC_INSTRUCTIONS: NfcStep[] = [
  {
    image: '/assets/nfc/nfc_step1.png',
    alt: 'Scanning NFC tag with smartphone',
    step: 1,
    text: 'common:pages.rfids.nfc_steps.step1',
  },
  {
    image: '/assets/nfc/nfc_step2.png',
    alt: 'NFC Tools app interface',
    step: 2,
    text: 'common:pages.rfids.nfc_steps.step2',
  },
  {
    image: '/assets/nfc/nfc_step3.png',
    alt: 'NFC tag details screen',
    step: 3,
    text: 'common:pages.rfids.nfc_steps.step3',
  },
];

const AddRfidInstructions: FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const smallScreen = useMediaQuery(
    `(max-width:${theme.breakpoints.values.sm + 70}px)`,
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height="100%"
      sx={{ overflowY: 'auto' }}
    >
      <Box mb={2}>
        <Typography variant="h2" textAlign="center" mb={1}>
          {t('common:pages.rfids.how_to_add_rfid')}
        </Typography>
        <Typography mb={2} variant="body1" textAlign="center">
          {t('common:pages.rfids.rfid_instructions')}
          <a
            href="itms-apps://apps.apple.com/app/nfc-tool/id1252962749"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: theme.palette.primary.main, margin: '0 0.5rem' }}
          >
            {t('common:pages.rfids.app_store')}
          </a>
          {t('common:pages.rfids.or')}
          <a
            href="https://play.google.com/store/apps/details?id=com.wakdev.wdnfc"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: theme.palette.primary.main, margin: '0 0.5rem' }}
          >
            {t('common:pages.rfids.play_store')}
          </a>
        </Typography>
      </Box>

      {smallScreen ? (
        <SliderBox width="100%" px={2}>
          <Slider {...SLIDER_SETTINGS}>
            {NFC_INSTRUCTIONS.map(stepData => (
              <Box
                key={stepData.step}
                display="flex"
                justifyContent="center"
                px={2}
              >
                <NfcStepContent {...stepData} />
              </Box>
            ))}
          </Slider>
        </SliderBox>
      ) : (
        <Box gap={2} display="flex" justifyContent="center" flexDirection="row">
          {NFC_INSTRUCTIONS.map(stepData => (
            <Box key={stepData.step}>
              <NfcStepContent {...stepData} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AddRfidInstructions;
